import { In } from 'typeorm'
import { Activity } from '@things-factory/worklist'
import { issue } from '@things-factory/worklist/dist-server/controllers/activity-instance/issue'
import { Role } from '@things-factory/auth-base'

import { DataOoc } from '../service/data-ooc/data-ooc.js'
import { DataSet } from '../service/data-set/data-set.js'

export async function issueOocResolve(
  dataOoc: DataOoc,
  dataSet: DataSet,
  correctiveInstruction: string,
  context: ResolverContext
): Promise<void> {
  const { domain, user, tx } = context.state
  const { resolverRoleId, outlierApprovalLine } = dataSet

  var activities = await tx.getRepository(Activity).find({
    where: {
      domain: domain.parentId ? In([domain.id, domain.parentId]) : { id: domain.id },
      name: 'OOC Resolve'
    }
  })

  // Prioritize the activity in the current domain
  // Assumes that if both exist, the one in my domain is the intended customization or override
  var activity = activities.find(a => a.domainId === domain.id) || activities.find(a => a.domainId === domain.parentId)

  if (activity) {
    const assigneeRole =
      resolverRoleId &&
      (await tx.getRepository(Role).findOneBy({
        domain: { id: In([domain.id, domain.parentId].filter(Boolean)) },
        id: resolverRoleId
      }))

    /* 해당 dataset의 작업 담당자(resolverRole)에게 OOC 해결을 위한 태스크를 지시한다. */
    if (assigneeRole) {
      const activityInstance = {
        name: `[OOC 조치] ${dataSet.name}`,
        description: dataSet.description,
        activityId: activity.id,
        dueAt: new Date(Date.now() + (activity.standardTime || 24 * 60 * 60) * 1000),
        input: {
          dataOocId: dataOoc.id,
          instruction: correctiveInstruction
        },
        assigneeRole,
        threadsMin: 1,
        threadsMax: 1,
        approvalLine: outlierApprovalLine
      }

      const resolveActivityInstance = await issue(activityInstance, context)
      await tx.getRepository(DataOoc).update({ id: dataOoc.id }, { resolveActivityInstance })
    } else {
      console.error(
        `Assignees are not set. So, Data OOC Resolve task for ${dataOoc.name}(${dataOoc.id}) could not be issued.`
      )
    }
  } else {
    console.error('OOC Resolve Activity not installed.')
  }
}
